import { datesEqual, formatDateIso } from '@helpers';
import { DateFacetRange } from '@models';
import { searchService } from '@services';
import { BaseFacetComponent } from '../base-facet.component';
import defaultHtml from './date-range-facet.component.hbs';

export class DateRangeFacetComponent extends BaseFacetComponent {
    protected override customTemplatePropertyName = 'dateRangeFacet';
    protected override defaultHtml = defaultHtml;

    private get range(): DateFacetRange | undefined {
        if (this.data?.range?.type === 'date') {
            return this.data.range;
        }

        return undefined;
    }

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data || !this.range) {
            return '';
        }

        const html = template({
            startValue: this.range.start.toISOString(),
            endValue: this.range.end.toISOString(),
            minValue: this.range.min.toISOString(),
            maxValue: this.range.max.toISOString()
        });

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll('[hawksearch-start]').forEach((e) => {
            e.addEventListener('hawksearch:date-picker-changed', ((event: CustomEvent) => {
                let value: Date | undefined = event.detail;

                if (!value) {
                    value = this.range!.min;
                }

                this.setFacetValue(value, this.range!.end);
            }) as EventListener);
        });

        this.shadowRoot?.querySelectorAll('[hawksearch-end]').forEach((e) => {
            e.addEventListener('hawksearch:date-picker-changed', ((event: CustomEvent) => {
                let value: Date | undefined = event.detail;

                if (!value) {
                    value = this.range!.max;
                }

                this.setFacetValue(this.range!.start, value);
            }) as EventListener);
        });
    }

    private updateInputElements(start: Date | undefined, end: Date | undefined): void {
        const startElement = this.shadowRoot?.querySelector('[hawksearch-start]') as HTMLInputElement | null;
        const endElement = this.shadowRoot?.querySelector('[hawksearch-end]') as HTMLInputElement | null;

        if (startElement) {
            startElement.value = start ? formatDateIso(start) : '';
        }

        if (endElement) {
            endElement.value = end ? formatDateIso(end) : '';
        }
    }

    private setFacetValue(start: Date | undefined, end: Date | undefined): void {
        if (!!start && !!end && start > end) {
            const tempValue = start;

            start = end;
            end = tempValue;
        }

        if (!start) {
            start = this.range!.start;
        }

        if (!end) {
            end = this.range!.end;
        }

        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);

        this.updateInputElements(start, end);

        if (datesEqual(start, this.range!.start) && datesEqual(end, this.range!.end)) {
            return;
        }

        searchService.setFacetValue(this.data!.field!, `${start?.toISOString() ?? ''},${end?.toISOString() ?? ''}`);
    }
}
